<template>
  <div class="border-wrap" :class="{ 'border-wrap__large': size === 'large' }">
    <div class="title" v-if="title">{{ title }}</div>
    <div class="content">
      <slot>
        <v-chart v-if="!isEmpty" :options="rawOptions" :autoresize="true" />
        <div class="no-data" v-else>暂无数据</div>
      </slot>
    </div>
  </div>
</template>

<script>
import { isEmpty, isObject, isString } from '@/utils/is';
export default {
  props: {
    title: String,
    options: {
      type: [Object, null],
      default: null
    },
    size: {
      type: String,
      default: 'normal'
    }
  },
  data() {
    return {};
  },
  computed: {
    isEmpty() {
      return (
        !isObject(this.options) ||
        !isObject(this.options.dataset) ||
        isEmpty(this.options.dataset.source)
      );
    },
    rawOptions() {
      if (this.isEmpty) return;

      let dimensions = this.options.dataset.dimensions.map(e => {
        if (isString(e) && e.slice(0, 1) === '_') return this.$t('demo.' + e.slice(1));

        return this.$t('demo.' + e);
      });

      const dataset = {
        dimensions,
        source: this.options.dataset.source.map(e => {
          const keys = Object.keys(e);

          const map = {};

          keys.forEach(key => {
            let k = null;

            if (isString(key) && key.slice(0, 1) === '_') {
              k = this.$t('demo.' + key.slice(1));
            } else {
              k = key;
            }

            if (isString(e[key]) && e[key].slice(0, 1) === '_') {
              map[k] = this.$t('demo.' + e[key].slice(1));
            } else {
              map[k] = e[key];
            }
          });

          return map;
        })
      };

      return Object.assign({}, this.options, { dataset, name: this.$t(this.options.name) });
    }
  }
};
</script>

<style lang="scss">
.border-wrap {
  background-image: url('~@/assets/image/customs/border-style.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;

  user-select: none;

  overflow: hidden;

  display: flex;
  flex-direction: column;

  height: 100%;

  &.border-wrap__large {
    background-image: url('~@/assets/image/customs/border-style-large.png');
  }

  .title {
    color: #00a6a1;

    padding: 5px 0 0 10px;
  }

  .content {
    flex: 1;
    height: 100%;
  }

  .no-data {
    height: 100%;
    color: #0ef;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
